import { useEffect, useState } from "react";
import SEO from "../components/shared/SEO";
import { useDispatch } from "react-redux";
import { getSeoData } from "../store/slices/seoSlice";
import OttCarousel from "../components/shared/OttCarousel";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { getOttPageData } from "../services/pagesService";
import VideoPopup from "../components/shared/VideoPopup";
import "swiper/css/pagination";
import "swiper/css";
import Loading from "../components/shared/Loading";

const Ott = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [featuredItems, setFeaturedItems] = useState<any>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const handleOpenPopup = (currentSrc: any) => {
    setCurrentItem(currentSrc);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setCurrentItem(null);
  };

  useEffect(() => {
    setIsDataLoading(true);
    dispatch(getSeoData({ breadcrumbTitle: "OTT" }));
    const fetchData = async () => {
      const response: any = await getOttPageData();

      setData(
        response?.data?.filter((itm: any) => itm?.name !== "Featured") || []
      );
      setFeaturedItems(
        response?.data?.filter((itm: any) => itm?.name === "Featured") || []
      );
      setIsDataLoading(false);
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  if (isDataLoading) {
    return <Loading />;
  }
  return (
    <>
      <SEO title="Ott - MESC" />
      {/* {isDataLoading && (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )} */}
      <main className="main-area fix">
        <div
          style={{ margin: "50px 0 16px 0" }}
          className="row justify-content-center"
        >
          {featuredItems?.length > 0 && (
            <div
              className="col-xl-9"
              style={{
                marginBottom: "32px",
              }}
            >
              {featuredItems.map((featureItm: any) => (
                <div
                  style={{
                    borderRadius: "10px",
                    padding: "16px",
                    border: "1px solid #B5B5C3",
                  }}
                >
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    observer={true}
                    loop={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    pagination={{ clickable: true }}
                    className="featured-swiper"
                  >
                    {featureItm?.mescOtts?.nodes?.map(
                      (eachItm: any, ind: number) => (
                        <SwiperSlide key={ind}>
                          <div
                            onClick={() => {
                              handleOpenPopup(eachItm?.ottMeta?.mescOttUrl);
                            }}
                            style={{
                              width: "100%",
                              height: "300px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              style={{
                                objectFit: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={
                                eachItm?.ottMeta?.mescOttThumbnail ||
                                "/assets/img/cw/1.png"
                              }
                              alt="img"
                            />
                          </div>
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                </div>
              ))}
            </div>
          )}
          {data?.length > 0 &&
            data?.map(
              (item: any, ind: number) =>
                item?.mescOtts?.nodes?.length > 0 && (
                  <OttCarousel currentItem={item} id={ind} />
                )
            )}
        </div>
      </main>
      {isPopupOpen && (
        <VideoPopup currentItemSrc={currentItem} onClose={handleClosePopup} />
      )}
    </>
  );
};

export default Ott;
